import {
  UploadWithExisting,
  type UploadWithExistingProps,
} from '../dapp-form/UploadWithExisting';

type MediaUploadWithExistingProps = Omit<UploadWithExistingProps, 'mediaType'>;

export function MediaUploadWithExisting(props: MediaUploadWithExistingProps) {
  return <UploadWithExisting mediaType="media" {...props} />;
}
